module.exports = __webpack_public_path__ + "static/media/coin-9.018ea76c.svg";